var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSecondSectionWork(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_489_3218",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.970459,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_489_3218)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 21.9705C3.45 21.9705 2.97917 21.7746 2.5875 21.383C2.19583 20.9913 2 20.5205 2 19.9705V8.97046C2 8.42046 2.19583 7.94963 2.5875 7.55796C2.97917 7.16629 3.45 6.97046 4 6.97046H8V4.97046C8 4.42046 8.19583 3.94963 8.5875 3.55796C8.97917 3.16629 9.45 2.97046 10 2.97046H14C14.55 2.97046 15.0208 3.16629 15.4125 3.55796C15.8042 3.94963 16 4.42046 16 4.97046V6.97046H20C20.55 6.97046 21.0208 7.16629 21.4125 7.55796C21.8042 7.94963 22 8.42046 22 8.97046V19.9705C22 20.5205 21.8042 20.9913 21.4125 21.383C21.0208 21.7746 20.55 21.9705 20 21.9705H4ZM4 19.9705H20V8.97046H4V19.9705ZM10 6.97046H14V4.97046H10V6.97046Z",
    fill: "#F8F8F8"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondSectionWork);
export default __webpack_public_path__ + "static/media/secondSection-Work.0d000fd0bf1b85de3d1d2123d782abd1.svg";
export { ForwardRef as ReactComponent };